import React, { useEffect, useState } from "react";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import axios from "axios";
import { message } from "antd";

const PostponeRequests = () => {
  const [requests, setRequests] = useState([]);

  async function fetchRequests() {
    try {
      const res = await axios.get("/api/postpone/all");
      if (res.data.success) {
        setRequests(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function approveRequest(id) {
    try {
      const res = await axios.put(`/api/postpone/approve/${id}`);
      if (res.data.success) {
        message.success("Request approved");
        fetchRequests();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function rejectRequest(id) {
    try {
      const res = await axios.put(`/api/postpone/reject/${id}`);
      if (res.data.success) {
        message.error("Request rejected");
        fetchRequests();
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <Layout>
      <AdminHeader title="Postpone Requests" redirect="/booking-list" />

      <div className="container px-4 py-3">

        {requests.length === 0 ? (
          <h4 className="text-center mt-5">No Postpone Requests Found</h4>
        ) : (
          requests.map((item) => (
            <div className="card p-3 my-3" key={item._id}>
        <h5>
  User: <strong>
    {item?.userId
      ? item.userId.fullName
      : item?.bookingId?._id || "Unknown Booking"}
  </strong>
</h5>


              <p>
                <strong>Trip:</strong> {item?.bookingId?.tripName}
              </p>
              <p>
                <strong>Old Date:</strong> {item.oldDate}
              </p>
              <p>
                <strong>New Date:</strong> {item.newDate}
              </p>
              <p>
                <strong>Reason:</strong> {item.reason}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span className={
                  item.status === "pending"
                    ? "text-warning"
                    : item.status === "approved"
                    ? "text-success"
                    : "text-danger"
                }>
                  {item.status.toUpperCase()}
                </span>
              </p>

              {item.status === "pending" && (
                <div className="d-flex gap-3 mt-2">
                  <button
                    className="btn btn-success"
                    onClick={() => approveRequest(item._id)}
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => rejectRequest(item._id)}
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </Layout>
  );
};

export default PostponeRequests;
